import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface accountState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: accountState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const accountSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    setAccounts: (state, action) => {
      state.totalRecords = action.payload.totalRecords;
      state.data = action.payload.data;
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
    },
    addNewAccount: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAccounts, addNewAccount, reset } = accountSlice.actions;

// selectors
export const getAccountDetails = (state: any) => state.accounts.data;
export const getAccountDetailsServiceId = (state: any) => state.accounts;

export default accountSlice.reducer;
